export const LOAD_ANALYTIC = 'LOAD_ANALYTIC';
